var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"identifier"},[_c('p',{staticClass:"identifier__first"},[_vm._v(_vm._s(_vm.firstId))]),_c('p',{staticClass:"identifier__second"},[_vm._v(_vm._s(_vm.secondId))])])}
var staticRenderFns = []

export { render, staticRenderFns }